<script lang="ts">import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { LocalIcon, RemoteIcon } from "@infinitro/icons";
import { menuAutoCollapsed } from "../state";
export let openSearchModal = () => null;
export let isButtonMode = false;
export let isOnToolbar = false;
let isMenuCollapsed = false;
menuAutoCollapsed.subscribe((value) => {
	isMenuCollapsed = value;
});
$: useAlternative = $stateUi.sidebar.sidebarStyle === "alternative";
$: useDefault = $stateUi.sidebar.sidebarStyle === "default";
$: useAlternative2 = $stateUi.sidebar.sidebarStyle === "alternative2";
$: useAlternative4 = $stateUi.sidebar.sidebarStyle === "alternative4";
</script>

<button
	aria-label={$t(Verbiage.search)}
	class:search-button-alternative={useAlternative || useAlternative4}
	class:search-button-alternative-4={useAlternative4}
	class:search-button-alternative-2={useAlternative2}
	class:search-button-alternative-collapsed={(useAlternative || useAlternative4) &&
		(isMenuCollapsed || isButtonMode)}
	class="search-button {isMenuCollapsed || isButtonMode
		? `${useDefault ? 'search-button-collapsed-default' : useAlternative2 ? 'search-button-collapsed-alternative-2' : 'search-button-collapsed'}`
		: ''}"
	class:search-button-collapsed-toolbar={isOnToolbar}
	on:click={openSearchModal}
	type="button"
>
	<div
		class="search-icon {isMenuCollapsed || isButtonMode ? 'search-icon-collapsed' : ''}"
		class:search-icon-alternative={useAlternative || useAlternative4}
		class:search-icon-alternative-4={useAlternative4}
		class:search-icon-alternative-collapsed={(useAlternative || useAlternative4) &&
			(isMenuCollapsed || isButtonMode)}
		class:search-icon-alternative-collapsed-4={useAlternative4 && (isMenuCollapsed || isButtonMode)}
	>
		{#if useAlternative4}
			<LocalIcon icon="SearchIcon" />
		{:else}
			<RemoteIcon icon="SearchIcon" />
		{/if}
	</div>
	{#if !(isMenuCollapsed || isButtonMode)}
		<span
			class:search-text-alternative={useAlternative || useAlternative2 || useAlternative4}
			class:search-text-alternative-4={useAlternative4}
			class="search-text">{$t(Verbiage.search)}</span
		>
	{/if}
</button>

<style>
	.search-button {
		height: 40px;
		width: 100%;
		cursor: pointer;
		border-radius: 16px;
		padding: 0.5rem;
		padding-top: 0.75rem;
		padding-bottom: 0.75rem;
		padding-left: 2.5rem;
		font-size: 14px;
		color: var(--color-neutral-100);
		background: var(--gradient-alternative-4);
		font-family: var(--font-main);
}
.search-button:focus {
		border-color: var(--color-secondary-500);
		outline: 2px solid transparent;
		outline-offset: 2px;
}
	.search-button {
		position: relative;
		display: flex;
		align-items: center;
		border-width: 1px;
		border-color: var(--color-neutral-900);
}

	.search-button-alternative {
		border-color: var(--color-accent-700);
		background-color: var(--color-background-500);
		border-radius: 12px;
}

	.search-button-alternative:focus {
		border-color: var(--color-accent-700);
		outline: 2px solid transparent;
		outline-offset: 2px;
}

	.search-button-alternative {
		background-image: unset;
	}

	.search-button-alternative-4 {
		border-width: 0px;
}

	.search-button-alternative-2 {
		position: relative;
		border-radius: 8px;
		border-style: none;
		background: linear-gradient(
			180deg,
			rgba(var(--color-background-900-rgb) / 0.6) 0%,
			rgba(var(--color-background-900-rgb) / 0.5) 100%
		);
}

	.search-button-alternative-2::before {
		position: absolute;
		inset: 0px;
		border-radius: 8px;
		padding: 1px;
		content: '';
		background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 100%);
		-webkit-mask:
			linear-gradient(#fff 0 0) content-box,
			linear-gradient(#fff 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
		z-index: 2;
}

	.search-icon {
		position: absolute;
		left: 0.75rem;
		display: flex;
		align-items: center;
}

	.search-icon-alternative {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.search-icon-alternative-4 {
		opacity: 0.5;
}

	.search-icon-collapsed {
		left: 50%;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		cursor: pointer;
}

	.search-icon-alternative-collapsed {
		width: 16px;
		color: var(--color-text-700);
}

	.search-icon-alternative-collapsed-4 {
		color: var(--color-text-100);
		opacity: 0.5;
}

	.search-button-collapsed {
		display: flex;
		height: 40px;
		width: 40px;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		padding: 0px;
}

	.search-button-collapsed-default {
		display: flex;
		height: 44px;
		width: 44px;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		padding: 0px;
}

	.search-button-collapsed-toolbar {
		height: 40px;
		width: 40px;
		border-radius: 12px;
}

	.search-button-alternative-collapsed {
		border-color: var(--color-accent-700);
		background-color: var(--color-background-500);
		border-radius: 8px;
		color: var(--color-text-700);
}

	.search-button-collapsed-alternative-2 {
		height: 40px;
		width: 100%;
		cursor: pointer;
		border-radius: 8px;
		padding: 0px;
}

	.search-text {
		font-size: 14px;
		opacity: 1;
}
	.search-text-alternative {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		opacity: 1 !important;
}
	.search-text-alternative-4 {
		opacity: 0.5 !important;
}
</style>
